// A field's limit counted as the core counts it: a character is a code
// point, as Go counts runes, never a UTF-16 unit, so an emoji counts once.
// A browser's maxlength counts UTF-16 units, and refuses text the core takes.

/**
 * What a field that takes at most `max` characters keeps of `text`, typed
 * with the caret at `caret`: when it holds more, the end of what was just
 * typed or pasted, before the caret, is cut, as a browser's maxlength cuts
 * it, and the caret stays after what is kept.
 */
export function keepCharacters(
	text: string,
	caret: number,
	max: number,
): { text: string; caret: number } {
	if ([...text].length <= max) return { text, caret };
	const after = text.slice(caret);
	const room = Math.max(0, max - [...after].length);
	const before = [...text.slice(0, caret)].slice(0, room).join('');
	return { text: before + after, caret: before.length };
}
